// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle-module_title_f2dd6f"};